 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"component-Card","1":"component-EduVideos","2":"page","3":"page-Home","4":"page-InvoiceDetails","5":"page-InvoiceList","6":"page-OrderDetails","7":"page-OrderList","8":"page-PaymentInvoice","9":"page-PaymentInvoiceRedirect","10":"page-ProductDetails","11":"page-ProductList","12":"page-Profile","13":"page-QuoteDetails","14":"page-QuoteList","15":"page-UserEdit","16":"page-UserList","17":"pages-v2","18":"pages-v2-ProductDetails","19":"component-Card-ConfirmOrderCardComponents","20":"component-CartModal-RemoveFromCartModal","21":"component-EduVideos-EduVideos","22":"component-ExportDataModal-ExportDataModal","23":"component-favicon-manifest","24":"component-svgs-svgs-d","25":"page-AccessRestricted","26":"page-Cart","27":"page-Home-ExploreCard","28":"page-Home-ExploreCardImagePosition","29":"page-Home-ListItemsCard","30":"page-InvoiceDetails-InvoiceDetailsView","31":"page-OrderConfirmation","32":"page-OrderDetails-OrderDetailsView","33":"page-PaymentInvoice-InvoicePaymentInfoCard","34":"page-PaymentInvoice-PaymentInvoice","35":"page-PaymentInvoiceRedirect-ErrorMessage","36":"page-PaymentInvoiceRedirect-PaymentInvoiceRedirect","37":"page-ProductDetails-ProductDetailsView","38":"page-Profile-ExportDataCard","39":"page-Profile-ExportDataCardContainer","40":"page-Profile-LocationCard","41":"page-Profile-Profile","42":"page-Profile-ProfileView","43":"page-Profile-UserInfoCardEdit","44":"page-Profile-UserInfoCardView","45":"page-Profile-UserInfoTitle","46":"page-Profile-useUpdateLoggedInUser","47":"page-QuoteDetails-QuoteDetailsView","48":"page-TermsAndConditions","49":"page-UserEdit-UserEditView","50":"page-UserList-UserListView","51":"pages-v2-ProductDetails-ProductDetailsView","52":"redux-sessionStorage","54":"component-favicon-android-icon-144x144-png","55":"component-favicon-android-icon-192x192-png","56":"component-favicon-android-icon-36x36-png","57":"component-favicon-android-icon-48x48-png","58":"component-favicon-android-icon-72x72-png","59":"component-favicon-android-icon-96x96-png","60":"component-favicon-apple-icon-114x114-png","61":"component-favicon-apple-icon-120x120-png","62":"component-favicon-apple-icon-144x144-png","63":"component-favicon-apple-icon-152x152-png","64":"component-favicon-apple-icon-180x180-png","65":"component-favicon-apple-icon-57x57-png","66":"component-favicon-apple-icon-60x60-png","67":"component-favicon-apple-icon-72x72-png","68":"component-favicon-apple-icon-76x76-png","69":"component-favicon-apple-icon-png","70":"component-favicon-apple-icon-precomposed-png","71":"component-favicon-browserconfig-xml","72":"component-favicon-favicon-16x16-png","73":"component-favicon-favicon-32x32-png","74":"component-favicon-favicon-96x96-png","75":"component-favicon-favicon-ico","76":"component-favicon-ms-icon-144x144-png","77":"component-favicon-ms-icon-150x150-png","78":"component-favicon-ms-icon-310x310-png","79":"component-favicon-ms-icon-70x70-png","80":"component-svgs-arrow_right-svg","81":"component-svgs-brenntag_logo-svg","82":"component-svgs-caret-svg","83":"component-svgs-cart-svg","84":"component-svgs-details-svg","85":"component-svgs-export-svg","86":"component-svgs-file_type_pdf-svg","87":"component-svgs-filter-svg","88":"component-svgs-gb-svg","89":"component-svgs-logo-svg","90":"component-svgs-phone-svg","91":"component-svgs-search-svg","92":"component-svgs-user_check-svg","94":"page-Home-PersonStandingInFrontOfScreen-svg","95":"page-Home-svg-Invoices-svg","96":"page-Home-svg-MyProfile-svg","97":"page-Home-svg-Orders-svg","98":"page-Home-svg-Products-svg"}[chunkId]||chunkId) + "-" + {"0":"6f4f6dbd71a2efdc0896","1":"436f35300ea7067a9f30","2":"1a06d013620450ac56b4","3":"f6bf6e5a5b54776ca11d","4":"065fde77336075b3db38","5":"decd536883189036abf7","6":"6cd3c75a19000a9f04bf","7":"1b348d2955af99d30405","8":"aefa9796a325790f31ae","9":"84e7c39c18ba4850a190","10":"6deb06c52296fadf3636","11":"ea5c3d7494a44cea22da","12":"ed939aefa726bf1fe18a","13":"a4021970c1803c320cf6","14":"620b057f21a43886bc9d","15":"74ebb4196deac4365cf7","16":"75bfde9d9072a50a2eb4","17":"8d69a085dddeefb25f43","18":"6e2c76b007be506745ad","19":"46e8aa6e8052bd4fa45b","20":"6d2548cbbd4758553a38","21":"d2c935b1d5a82264d7e1","22":"0823764541844538d719","23":"29848e3497c8b696f748","24":"5a8a437c80edaab03317","25":"6f39fbd8d541bb7af987","26":"f0bd5d05412b3f7a9fc9","27":"63cbb31fcb7949d86a68","28":"ae1a3719416e30843a92","29":"97931930f1b84076188c","30":"98f915075b395955088f","31":"f40f7664687469807dff","32":"75242090bf9fd51428f8","33":"fd54c1852dd8f6aa9084","34":"659afea6db2baaadc5e7","35":"730fc6d0ce05ac9e04c7","36":"7c268e568e1ade456803","37":"2b5327401c60bdccc3dc","38":"ca986671baeff4a6b112","39":"a4a6dd1c346e0abe5091","40":"4fe2e34cf1fe4dae7b03","41":"e3acdba408f74f87a1f4","42":"d54fe4198391d251dc23","43":"6f78febea47e25f4ffda","44":"04a2110fb07b69441569","45":"f9c62e0047c7b94a2d54","46":"ff725953e32b73424894","47":"a762106baa48bf4e0afe","48":"01681173806c59c3a157","49":"b15bf7835cb383602d5a","50":"e7d0b0685c2acb3100a5","51":"125df83c5c76976b6b08","52":"a97c05f5ff4e3ad9efaf","54":"81f6117b253ec4f6d32a","55":"ac2104336eb1b41f17b6","56":"b599c588768cb80fe8ae","57":"680957974f9586d19739","58":"516b01a032aa42170b74","59":"331555d3d13f2227edd6","60":"1c379ebfb23cf4bb1f2f","61":"e418f3270a945c22a705","62":"32835dda1f2fb9836472","63":"b0c1c88c0e4dbe5d317b","64":"cddb9690f60c62e452a5","65":"4e8e78277082aadb289f","66":"e3e116e545bfbe61034d","67":"8fdb4b78869052f27821","68":"f0984c38285e4e9e8c57","69":"4e052aa23b07e22b093c","70":"5fae87c21d02e73e67a0","71":"027866ac3db49858974a","72":"d1c827206f6b5505a097","73":"13103eb26ce0c37c5b01","74":"4519ed2afa0ee023c542","75":"f136e822ff4f1c4a0c65","76":"a6c013560701a4041cb9","77":"0933ee8c7ffa2c4210d3","78":"e8a6efa77a0cbe91629e","79":"80fb3d468713e8199684","80":"f3956e7d82e76e0b342b","81":"6caadb780edbca8bc35e","82":"7a6c60fe4e71ccba740a","83":"062b60eea04083535034","84":"ffa8f757e6f39d8f4082","85":"af05f4ed73c9bf884b9f","86":"664573d0bb5ae6000b2e","87":"93c3dfd659596b4b4227","88":"419056a5d31701a67829","89":"72efdb292b35e7d27118","90":"99a59e3e491d8b5bf2b9","91":"4a43f604b3f8268e49d6","92":"5ad5846f63ff1516b5c7","94":"e253e84db46c44d8ffeb","95":"205fd6a6acabe02dc505","96":"c519bc76fa211e16a1a8","97":"00f2ba0f13f2d8f7a8a3","98":"c473def9432a31126a16","100":"39a53ff4996ae2150e48","101":"07e54e839920f27ac09a","102":"5e74041d90dee2ee2711"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/connect/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
